import { useContext } from 'react';
import { LaunchDarklyContext } from '~/components/providers/LaunchDarklyProvider';

import { ffDefaults } from '~/constants';

export const useLaunchDarklyContext = () => {
  const { context: launchDarklyContext, flags, loading, ldClient } = useContext(LaunchDarklyContext);
  const flagsWithDefaults = {
    ...ffDefaults,
    ...flags,
  };

  return { launchDarklyContext, flags: flagsWithDefaults, loading, ldClient };
};
